import React from 'react';
import PropTypes from 'prop-types';
import Links from 'components/Link';

class BackToBrandwireMobile extends React.PureComponent {
  render() {
    return (
      <Links className="" to={this.props.sponsoredUrl}>
        <span>{this.props.backToAgencyText}</span>
      </Links>
    );
  }
}

BackToBrandwireMobile.propTypes = {
  sponsoredUrl: PropTypes.string,
  backToAgencyText: PropTypes.string,
};

BackToBrandwireMobile.defaultProps = {
  sponsoredUrl: undefined,
  backToAgencyText: undefined,
};

export default BackToBrandwireMobile;
